"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileProviderItemType;
(function (FileProviderItemType) {
    FileProviderItemType[FileProviderItemType["File"] = 0] = "File";
    FileProviderItemType[FileProviderItemType["Folder"] = 1] = "Folder";
})(FileProviderItemType = exports.FileProviderItemType || (exports.FileProviderItemType = {}));
var ImageLoadState;
(function (ImageLoadState) {
    ImageLoadState[ImageLoadState["NotLoaded"] = 0] = "NotLoaded";
    ImageLoadState[ImageLoadState["Loaded"] = 1] = "Loaded";
    ImageLoadState[ImageLoadState["ErrorLoading"] = 2] = "ErrorLoading";
})(ImageLoadState = exports.ImageLoadState || (exports.ImageLoadState = {}));
//# sourceMappingURL=FileProviderItemViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/store/schema/FileProviderItemViewState.js
// module id = 1762
// module chunks = 2 3 43 106 107